import React from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import Input from '../../components/input'
import formValidation from './formValidation'
import { useTranslation } from 'react-i18next'


interface LoginProps {
  onSubmit: (values: LoginValues) => void
  children?: React.ReactNode
  email: string
  password: string
}

interface LoginValues {
  email: string
  password: string
}

const InnerForm: React.FunctionComponent<
  LoginProps & FormikProps<LoginValues>
> = ({ values, errors, handleChange, handleBlur, touched, children }) => {
  const { t } = useTranslation()



  return (
    <div className='container-view plan-card top-card-secondary col-12 col-md-4'>
      <div className='container-title'>
        <h2 className='h2-title'>{`${t('START')}`}</h2>
        <span className='display-grid'>
          {`${t('DONT_HAVE_AN_ACCOUNT')}`}
          <a className='link' href='/sign-up'>
            {`${t('SIGN_UP')}`}
          </a>
        </span>
      </div>
      <Form>
        <Input
          id='email'
          label={`${t('EMAIL')}`}
          type='text'
          value={values.email}
          onChange={handleChange}
          touched={touched.email}
          classNameInput='input'
          required
          classNameLabel='label-left'
        />
        <Input
          id='password'
          label={`${t('PASSWORD')}`}
          type='password'
          value={values.password}
          onChange={handleChange}
          touched={touched.password}
          classNameInput='input'
          required
          classNameLabel='label-left'
        />
        <div className='container-button'>
          <button className='button-first  width-200' type='submit'>
            {`${t('LOGIN')}`}
          </button>
        </div>
       
      </Form>
    </div>
  )
}

const LoginForm = withFormik<LoginProps, LoginValues>({
  mapPropsToValues: (props) => {
    const initialValues: LoginValues = {
      email: props.email || '',
      password: props.password || '',
    }
    return { ...initialValues, ...props }
  },
  validationSchema: formValidation,
  handleSubmit(values: LoginValues, { props }) {
    props.onSubmit(values)
  },
})(InnerForm)
export default LoginForm
